import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { ListadoSirenasComponent } from './listado-sirenas/listado-sirenas.component';
import { SirenasRoutingModule } from './routing';
import { MapaSirenasComponent } from './mapa-sirenas/mapa-sirenas.component';
import { CrearEditarSirenasComponent } from './crear-editar-sirenas/crear-editar-sirenas.component';
import { FlotanteSirenasComponent } from './mapa-sirenas/flotante-sirenas/flotante-sirenas.component';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { DetallesIntegracionComponent } from './detalles-integracion/detalles-integracion.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { ServicioTecnicoMasivoComponent } from './servicio-tecnico-masivo/servicio-tecnico-masivo.component';
import { ClienteSelectorComponent } from '../../../componentes/selectores/cliente-selector/cliente-selector.component';
import { RangosHorariosComponent } from '../../standalone/rangos-horarios/rangos-horarios.component';
import { CardHeaderComponent } from '../../../componentes/card-header/card-header.component';
import { SectionTitleComponent } from '../../../componentes/section-title/section-title.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { EmptyStateComponent } from '../../../componentes/empty-state/empty-state.component';
import { StatCardComponent } from '../../../componentes/stat-card/stat-card.component';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';

@NgModule({
  declarations: [
    ListadoSirenasComponent,
    MapaSirenasComponent,
    CrearEditarSirenasComponent,
    DetallesIntegracionComponent,
    FlotanteSirenasComponent,
    ServicioTecnicoMasivoComponent,
  ],

  imports: [
    CommonModule,
    AuxiliaresModule,
    SirenasRoutingModule,
    MapaFacilComponent,
    MapaFacilV2Component,
    MapCardComponent,
    ClienteSelectorComponent,
    RangosHorariosComponent,
    CardHeaderComponent,
    SectionTitleComponent,
    InfoBannerComponent,
    EmptyStateComponent,
    StatCardComponent,
    PasosNavComponent,
    ListadoAsignacionsComponent,
    ...PIEZAS_DETALLE,
  ],
})
export class SirenasModule {}
